module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tour-wizard"
  }, [_c('div', {
    staticClass: "tour-wizard__wrapper"
  }, [_c('header', {
    staticClass: "tour-wizard__header"
  }, [_c('router-link', {
    staticClass: "tour-wizard__header--logo",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/svg/logo.svg"),
      "alt": " "
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tour-wizard__header--tour-name",
    attrs: {
      "id": "tourName"
    }
  }, [_vm._v(_vm._s(_vm.tour.name))]), _vm._v(" "), _c('button', {
    staticClass: "tour-wizard__header--exit",
    attrs: {
      "aria-label": "Exit tour"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.exit()
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 320 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"
    }
  })])])], 1), _vm._v(" "), _c('section', {
    staticClass: "tour-wizard__slides--rail",
    attrs: {
      "aria-labelledby": "tourName"
    },
    on: {
      "touchstart": _vm.touchStart
    }
  }, [_c('div', {
    staticClass: "tour-wizard__slides",
    style: ({
      width: _vm.sliderTotalWidth,
      left: _vm.sliderLeftPosition
    })
  }, _vm._l((this.tour.slides), function(slide, index) {
    return _c('div', {
      staticClass: "tour-wizard__slide",
      class: [{
        active: _vm.currentSlide === index + 1
      }],
      style: ({
        maxWidth: _vm.slideMaxWidth
      }),
      attrs: {
        "role": "group",
        "aria-labelledby": "tourPagination"
      }
    }, [_c('div', {
      staticClass: "tour-wizard__slide--media",
      class: ['type-' + (slide.media.type || 'image')]
    }, [(slide.media.type === 'image') ? [_c('img', {
      attrs: {
        "src": slide.media.resource,
        "alt": slide.media.alt || ' '
      }
    })] : _vm._e(), _vm._v(" "), (slide.media.type === 'video') ? [_c('video', {
      attrs: {
        "loop": "",
        "controls": "",
        "title": slide.media.title || ''
      }
    }, _vm._l((slide.media.sources), function(source) {
      return _c('source', {
        attrs: {
          "src": source.src,
          "type": source.type || 'video/mp4'
        }
      })
    }), 0)] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "tour-wizard__slide--text"
    }, [_c('div', {
      staticClass: "tour-wizard__slide--text__wrapper"
    }, [_c('h1', {
      staticClass: "tour-wizard__slide--text__title",
      domProps: {
        "innerHTML": _vm._s(slide.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tour-wizard__slide--text__text",
      domProps: {
        "innerHTML": _vm._s(slide.text)
      }
    }), _vm._v(" "), (index === 0) ? _c('div', {
      staticClass: "tour-wizard__slide--text__hint"
    }, [_c('div', [_c('svg', {
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "role": "img",
        "id": "swipe",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "width": "31.14",
        "height": "32",
        "viewBox": "0 0 31.14 32"
      }
    }, [_c('defs', [_c('clipPath', {
      attrs: {
        "id": "clip-path"
      }
    }, [_c('rect', {
      attrs: {
        "id": "Rectangle_1482",
        "data-name": "Rectangle 1482",
        "width": "31.14",
        "height": "32",
        "fill": "currentColor"
      }
    })])]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "Group_13162",
        "data-name": "Group 13162",
        "clip-path": "url(#clip-path)"
      }
    }, [_c('path', {
      attrs: {
        "id": "Path_11133",
        "data-name": "Path 11133",
        "d": "M167.585,93.256a3.083,3.083,0,0,0-.359.022,2.937,2.937,0,0,0-1.263.461,2.769,2.769,0,0,0-.105-.262A3,3,0,0,0,164.8,92.24a2.977,2.977,0,0,0-3.262-.037,3.018,3.018,0,0,0-1.358-1.691,2.931,2.931,0,0,0-1.12-.373,3.027,3.027,0,0,0-.359-.022,2.985,2.985,0,0,0-.6.062,2.933,2.933,0,0,0-.854.319V88.378a2.98,2.98,0,0,0-2.982-3.018,2.985,2.985,0,0,0-2.982,2.982v6.549c0,1.162,0,2.37,0,3.527a3.616,3.616,0,0,0-2.971-1.674h-.221l-.213.06a2.985,2.985,0,0,0-2.063,3.674l1.444,5.25c.315,1.146.392,1.34.425,1.424,1.578,3.992,5.588,6.25,11.6,6.529l.037,0h.132a14.8,14.8,0,0,0,4.4-.633,10.84,10.84,0,0,0,3.494-1.8,8.112,8.112,0,0,0,3.22-6.286c0-.034,0-.2,0-1.366s0-3.329,0-7.357a2.986,2.986,0,0,0-2.982-2.982m1.378,11.675c-.075,3.955-3.709,7.148-9.512,7.148h-.1c-4.1-.191-8.563-1.427-10.18-5.518-.077-.195-.327-1.1-.37-1.259l-1.445-5.254a1.384,1.384,0,0,1,.954-1.7,2.009,2.009,0,0,1,1.822,1.38l1.252,4.447c.009.031.02.062.032.093a.76.76,0,0,0,.709.487h0a.757.757,0,0,0,.757-.757c0-.886,0-5.464,0-9.442,0-.731,0-1.442,0-2.106V88.342a1.382,1.382,0,0,1,1.548-1.37,1.4,1.4,0,0,1,1.212,1.406v10.3a.84.84,0,0,0,1.681,0V93.1a1.384,1.384,0,0,1,1.38-1.38,1.411,1.411,0,0,1,.168.01,1.331,1.331,0,0,1,.561.2,1.434,1.434,0,0,1,.65,1.2v6.306a.84.84,0,0,0,1.681,0V94.716a1.38,1.38,0,0,1,2.759,0v5.963a.84.84,0,1,0,1.681,0v-4.4a1.383,1.383,0,0,1,1.379-1.416,1.384,1.384,0,0,1,1.38,1.38s0,8.681,0,8.693",
        "transform": "translate(-139.427 -81.682)",
        "fill": "currentColor"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "id": "Path_11134",
        "data-name": "Path 11134",
        "d": "M2.7,2.748,4.083,1.364A.8.8,0,0,0,4.1.239.791.791,0,0,0,2.979.232L.231,2.979h0Q.206,3,.184,3.031l-.026.034c-.008.011-.017.022-.025.034s-.014.023-.021.035l-.019.031C.087,3.177.081,3.19.076,3.2s-.011.022-.016.034-.009.024-.013.036S.038,3.3.034,3.309s-.006.024-.009.037-.007.025-.009.038,0,.029-.007.043,0,.022,0,.034a.8.8,0,0,0,0,.156c0,.011,0,.022,0,.034s0,.029.007.043.006.026.009.038,0,.022.008.032l0,0c0,.013.009.025.013.037s.008.024.013.036.01.022.016.033.011.025.018.037l.018.031c.007.012.014.024.022.036l.024.032c.007.01.014.02.023.03s.031.035.047.052L.231,4.1,2.964,6.831a.8.8,0,0,0,1.126.021A.791.791,0,0,0,4.1,5.727l-1.4-1.4h7.322a.791.791,0,0,0,0-1.581Z",
        "transform": "translate(0 0)",
        "fill": "currentColor"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "id": "Path_11135",
        "data-name": "Path 11135",
        "d": "M436.562,4.324l-1.383,1.383a.8.8,0,0,0-.021,1.126.791.791,0,0,0,1.125.007l2.748-2.748h0q.025-.025.047-.052c.008-.009.019-.024.026-.034s.017-.022.025-.034.014-.023.021-.035l.019-.031c.006-.012.012-.024.017-.036s.011-.022.016-.034.009-.024.013-.036.009-.024.013-.037.006-.024.009-.037.007-.025.009-.038,0-.029.006-.043,0-.022,0-.034a.8.8,0,0,0,0-.156c0-.011,0-.022,0-.034s0-.029-.006-.043-.006-.026-.009-.038,0-.022-.008-.032l0,0c0-.013-.009-.025-.013-.037s-.008-.024-.013-.036-.01-.022-.016-.033-.011-.025-.018-.037-.012-.02-.018-.031-.014-.024-.022-.036l-.023-.032-.023-.03c-.015-.018-.031-.035-.047-.052l-.005-.006L436.3.241A.8.8,0,0,0,435.171.22a.791.791,0,0,0-.007,1.125l1.4,1.4H429.24a.791.791,0,0,0,0,1.581Z",
        "transform": "translate(-409.987 0)",
        "fill": "currentColor"
      }
    })])]), _vm._v(" "), _c('svg', {
      staticClass: "svg-inline--fa fa-square-arrow-left",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fal",
        "data-icon": "square-arrow-left",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M336 240H150.6l68.69-68.69c6.25-6.25 6.25-16.38 0-22.62s-16.38-6.25-22.62 0l-96 96C97.56 247.8 96 251.9 96 256s1.562 8.184 4.688 11.31l96 96c6.25 6.25 16.38 6.25 22.62 0s6.25-16.38 0-22.62L150.6 272H336c8.844 0 16-7.154 16-15.1C352 247.2 344.8 240 336 240zM384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM416 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32V416z"
      }
    })]), _vm._v(" "), _c('svg', {
      staticClass: "svg-inline--fa fa-square-arrow-right",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fal",
        "data-icon": "square-arrow-right",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M251.3 148.7c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62L297.4 240H112C103.2 240 96 247.2 96 255.1C96 264.8 103.2 272 112 272h185.4l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.62s16.38 6.25 22.62 0l96-96C350.4 264.2 352 260.1 352 255.1s-1.562-8.184-4.688-11.31L251.3 148.7zM384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM416 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32V416z"
      }
    })])]), _vm._v(" "), _c('div', [_vm._v("\n                  Navigate this slider by using the arrows on your keyboard or by clicking on the previous and next buttons below. If you are on a mobile device, swipe left/right.\n                ")])]) : _vm._e()])])])
  }), 0)]), _vm._v(" "), _c('footer', {
    staticClass: "tour-wizard__footer"
  }, [_c('div', {
    staticClass: "tour-wizard__pagination"
  }, [_c('div', {
    staticClass: "tour-wizard__pagination--previous"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.canGoToThePrevious,
      "aria-disabled": !_vm.canGoToThePrevious
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.previous()
      }
    }
  }, [_c('span', [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M447.1 256c0 13.25-10.76 24.01-24.01 24.01H83.9l132.7 126.6c9.625 9.156 9.969 24.41 .8125 33.94c-9.156 9.594-24.34 9.938-33.94 .8125l-176-168C2.695 268.9 .0078 262.6 .0078 256S2.695 243.2 7.445 238.6l176-168C193 61.51 208.2 61.85 217.4 71.45c9.156 9.5 8.812 24.75-.8125 33.94l-132.7 126.6h340.1C437.2 232 447.1 242.8 447.1 256z"
    }
  })]), _vm._v("\n              " + _vm._s(_vm.previousButtonText) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tour-wizard__pagination--controls",
    attrs: {
      "id": "tourPagination",
      "aria-live": "polite",
      "aria-labelledby": 'Slide ' + _vm.currentSlide + ' of ' + _vm.totalSlides
    }
  }, [_vm._v("\n          " + _vm._s(_vm.currentSlide) + "/" + _vm._s(_vm.totalSlides) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tour-wizard__pagination--next"
  }, [_c('button', {
    class: [{
      exit: !_vm.canGoToTheNext
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.canGoToTheNext ? _vm.next() : _vm.exit()
      }
    }
  }, [_c('span', [(_vm.canGoToTheNext) ? [_vm._v("\n                " + _vm._s(_vm.nextButtonText) + "\n                "), _c('svg', {
    staticClass: "svg-inline--fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "arrow-right",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 320 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"
    }
  })]), _vm._v("\n                Exit tour\n              ")]], 2)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c700092","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tour-wizard/TourWizard.vue
// module id = 972
// module chunks = 0